import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import messagesApis from "../../api/messagesApis";
import { PaginatedMessageResponse } from "../../types/messageType";

interface MessagesState {
  messages: any[];
  isLoading: boolean;
  filters: {
    staffId?: number;
    studentId?: number;
    message?: string;
    messageType?: "SENT" | "RECEIVED";
  };
   pagination: {
    currentPage: number;
    pageSize: number;
    totalElements: number;
    totalPages: number;
  };
}

const initialState: MessagesState = {
  messages: [],
  isLoading: false,
  pagination: {
    currentPage: 0,
    pageSize: 10,
    totalElements: 0,
    totalPages: 0,
  },
  filters: {},
};

export const fetchMessages = createAsyncThunk<
  PaginatedMessageResponse,
  {
    branchCode: string;
    page: number;
    size: number;
    staffId?: number;
    studentId?: number;
    message?: string;
    messageType?: "SENT" | "RECEIVED" | "OTHER";
  }
>("messages/fetchMessages", async (params) => {
  const response = await messagesApis.getMessages(params);
  return response!.data;
});

const messagesSlice = createSlice({
  name: "messages",
  initialState,
  reducers: {
    setPagination: (state, action) => {
      state.pagination.currentPage = action.payload.currentPage;
      state.pagination.pageSize = action.payload.pageSize;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMessages.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchMessages.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload) return;

        state.messages = action.payload.content;
        state.pagination.totalElements = action.payload.totalElements;
        state.pagination.totalPages = action.payload.totalPages;
      })
      .addCase(fetchMessages.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export const { setPagination, setFilters } = messagesSlice.actions;
export default messagesSlice.reducer;
